import { render, staticRenderFns } from "./AdvancedInsights.vue?vue&type=template&id=27c8cdeb&scoped=true"
import script from "./AdvancedInsights.vue?vue&type=script&lang=js"
export * from "./AdvancedInsights.vue?vue&type=script&lang=js"
import style0 from "./AdvancedInsights.vue?vue&type=style&index=0&id=27c8cdeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c8cdeb",
  null
  
)

export default component.exports